'use client';
import React from 'react';
import Link from 'next/link';

import isFullUrl from '@src/utils/isFullUrl';

import { NextLinkPropTypes } from './NextLink.types';

const NextLink: React.FC<NextLinkPropTypes> = ({
  className,
  locale,
  href = '/',
  children,
  ariaLabel,
  dataPseudo,
  replace,
  style,
  title,
  target = '_self',
  prefetch = false,
}) => {
  const localeOverwrite = locale && locale !== 'en' ? `/${locale}${href}` : href;

  if (isFullUrl({ url: href })) {
    return (
      <a
        className={`cursor-pointer ${className}`}
        style={style}
        href={href}
        aria-label={ariaLabel}
        data-pseudo={dataPseudo}
        target='_blank'
        title={title}
      >
        {children}
      </a>
    );
  } else if (href.startsWith('#')) {
    return (
      <span className={`cursor-pointer ${className}`} aria-label={ariaLabel} title={title}>
        {children}
      </span>
    );
  } else {
    return (
      <Link
        data-pseudo={dataPseudo}
        className={`cursor-pointer ${className}`}
        replace={replace}
        href={localeOverwrite}
        aria-label={ariaLabel}
        title={title}
        target={target}
        style={style}
        prefetch={prefetch}
      >
        {children}
      </Link>
    );
  }
};

export default NextLink;
